import config from '../config';
import { isEmptyString } from '@/src/shared/utils/string';

export const websiteBaseUrl = config.websiteBaseUrl;
export const dashboardBaseUrl = config.dashboardBaseUrl;
export const DASHBOARD_PREFIX = '/dashboard';

export const Routes = {
  auth: {
    logout: () => '/auth/logout',
  },
  landings: {
    home: () => '/',
    aboutUs: () => '/about',
    tryVusocialVideo: () => '/try-vusocial-video',
    publish: () => '/product/publish',
    smartAds: () => '/product/smart-ads',
    emailMarketing: () => '/product/email-marketing',
    leads: () => '/product/leads',
    mlsListings: () => '/product/mls-listings',
    premiumBranding: () => '/product/premium-branding',
    personalIntro: () => '/product/personal-intro',
  },
  external: {
    help: 'https://help.roomvu.com/en/',
    ctct: 'https://www.constantcontact.com/partner-offer/real-estate?pn=roomvu&promotionCode=ROOMVU30&utm_source=roomvu.com&utm_medium=partner-website&utm_campaign=us_i_cn_in_pn_roomvu_integrations&cc=indirect_roomvu_integrations-hub',
    wordpressIntegrationGuide:
      'https://www.roomvu.com/academy/how-to-integrate-roomvu-into-your-wordpress-website/',
  },
};

export const withAgentDashboardPrefix = (href?: string) => {
  if (isEmptyString(href)) {
    return dashboardBaseUrl;
  }
  return dashboardBaseUrl + href;
};
